import { render, staticRenderFns } from "./HistorySwiper.vue?vue&type=template&id=43b5cb76&scoped=true"
import script from "./HistorySwiper.vue?vue&type=script&lang=js"
export * from "./HistorySwiper.vue?vue&type=script&lang=js"
import style0 from "./HistorySwiper.vue?vue&type=style&index=0&id=43b5cb76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b5cb76",
  null
  
)

export default component.exports